import { render, staticRenderFns } from "./exclusionOffice.vue?vue&type=template&id=1e0aa184&"
import script from "./exclusionOffice.vue?vue&type=script&lang=js&"
export * from "./exclusionOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0aa184')) {
      api.createRecord('1e0aa184', component.options)
    } else {
      api.reload('1e0aa184', component.options)
    }
    module.hot.accept("./exclusionOffice.vue?vue&type=template&id=1e0aa184&", function () {
      api.rerender('1e0aa184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/exclusionOffice.vue"
export default component.exports